<template>
    <div :class="wrapperClasses">
        <slot name="header" />
        <slot />
    </div>
</template>

<script>
// Mixins
import styles from '../mixins/styles.js';

export default {
    name: 'Card',
    mixins: [styles],
    computed: {
        wrapperClasses: function () {
            return [ this.cssClasses.pcc__cardComponent ];
        }
    },
}
</script>
